/** @format */

export interface IHomrSpot {
  border?: boolean;
  contentName: string;
  link?: string;
  message?: string;
}
